export default __webpack_public_path__ + "static/media/ngma-logo.3687b5d4.png";